/*
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDBadge from "components/MDBadge";

import Swal from "sweetalert2";

// Material Dashboard 2 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// NewEvent page components
import EventImage from "./components/EventImage";
import FormFields from "./components/FormFields";
import EventDescription from "./components/Description";
import EventImageCover from "./components/EventImageCover";
import { updateEventApi, updateEventImgsApi } from "api/events";
import { fixEventCinemaTicketsApi } from "api/tickets";

import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";

import { CircularProgress } from "@mui/material";
import EventImageSieges from "./components/EventImageSieges";
import EventImages from "./components/EventImages";

function UpdateEvent() {
  const { eventID } = useParams();
  const navigate = useNavigate();

  const [formValue, setFormValue] = useState({
    eventMainImg: null,
    eventCoverImg: null,
    eventSiegesImg: null,
    otherEventImgs: null,
    description: "",
    eventInfo: {},
  });
  const [newEventLoading, setNewEventLoading] = useState(false);
  const [fixCinemaLoading, setFixCinemaLoading] = useState(false);

  // useEffect(() => {
  //   console.log("formValue changed:", formValue);
  // }, [formValue]);

  const handleEventMainImg = async (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        eventMainImg: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleEventCoverImg = async (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        eventCoverImg: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleEventSiegeImg = async (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        eventSiegesImg: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleEventImgs = async (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        otherEventImgs: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleUpdateEvent = async () => {
    try {
      setNewEventLoading(true);

      const eventImgObject = {
        eventMainImg: formValue.eventMainImg,
        eventCoverImg: formValue.eventCoverImg,
        eventSiegesImg: formValue.eventSiegesImg,
        otherEventImgs: formValue.otherEventImgs,
      };

      const removeIdFromArray = (arr) => {
        if (Array.isArray(arr)) {
          return arr.map((obj) => {
            const { _id, ...rest } = obj; // Destructure and remove _id from each object
            return rest;
          });
        }
        return arr; // Return unchanged if not an array
      };

      const eventObject = {
        eventTitle: formValue?.eventInfo?.eventTitle || "",
        promoVideo: formValue?.eventInfo?.promoVideo || "",
        address: formValue?.eventInfo?.address || "",
        description: formValue?.description || "",
        eventCategory:
          formValue?.eventInfo?.eventCategory?.length > 0
            ? formValue?.eventInfo?.eventCategory.map((el) => el._id)
            : [],
        eventPlace: removeIdFromArray(formValue?.eventInfo?.eventPlace),
        eventSiege: removeIdFromArray(formValue?.eventInfo?.eventSiege),
        eventStand: removeIdFromArray(formValue?.eventInfo?.eventStand),
        socialLink: removeIdFromArray(formValue?.eventInfo?.socialLink),

        onlineReservation: formValue?.eventInfo?.onlineReservation,
        isSelectetivePlaces: formValue?.eventInfo?.isSelectetivePlaces,
        seatIoId: formValue?.eventInfo?.seatIoId,
        isSoldOut: formValue?.eventInfo?.isSoldOut,
        isCinema: formValue?.eventInfo?.isCinema,
        isCirque: formValue?.eventInfo?.isCirque,
        city: formValue?.eventInfo?.city || "",
        eventDateList: formValue?.eventInfo?.eventDateList
      };

      if ((formValue?.eventInfo?.isCinema || formValue?.eventInfo?.isCirque) && formValue?.eventInfo?.eventDateList?.length > 0) {
        // eventObject.eventDateList = formValue?.eventInfo?.eventDateList;
        // eventObject.eventDateList = formValue?.eventInfo?.eventDateList.map((showtime) => ({
        //   ...showtime,
        //   // prices: showtime.prices.map(({ isSoldOut, ...rest }) => rest), // Remove isSoldOut from prices
        //   prices: showtime.prices, // Remove isSoldOut from prices
        // }));

        let earliestStartDate = null;
        let latestEndDate = null;
        let earliestEventDate = null;
        let earliestCloseDoorDate = null;

        // console.log("formValue?.eventInfo?.eventDateList", formValue?.eventInfo?.eventDateList)
        // console.log("eventObject", eventObject)
        // return 

        formValue?.eventInfo?.eventDateList?.map((showtime) => {
          if (showtime.startDate) {
            const currentDate = new Date(`${showtime.startDate}`);
            if (!earliestStartDate || currentDate < earliestStartDate) {
              earliestStartDate = currentDate;
            }
          }
          if (showtime.endDate) {
            const currentDate = new Date(`${showtime.endDate}`);
            if (!latestEndDate || currentDate > latestEndDate) {
              latestEndDate = currentDate;
            }
          }
          if (showtime.eventDate) {
            const currentDate = new Date(`${showtime.eventDate}`);
            if (!earliestEventDate || currentDate < earliestEventDate) {
              earliestEventDate = currentDate;
            }
          }
          if (showtime.eventCloseDoorDate) {
            const currentDate = new Date(`${showtime.eventCloseDoorDate}`);
            if (!earliestCloseDoorDate || currentDate < earliestCloseDoorDate) {
              earliestCloseDoorDate = currentDate;
            }
          }
        });

        if (earliestStartDate) eventObject.startDate = earliestStartDate.toISOString();
        if (latestEndDate) eventObject.endDate = latestEndDate.toISOString();
        if (earliestEventDate) eventObject.eventDate = earliestEventDate.toISOString();
        if (earliestCloseDoorDate) eventObject.eventCloseDoorDate = earliestCloseDoorDate.toISOString();
      }
      else {
        const startDate = formValue?.eventInfo?.startDate;
        const startTime = formValue?.eventInfo?.startTime;
        if (startDate) {
          const [year, month, day] = startDate.split("-").map(Number);
          const [hour, minute] = startTime ? startTime.split(":").map(Number) : [0, 0];
          const dateObjUtc = new Date(Date.UTC(year, month - 1, day, hour, minute));
          eventObject.startDate = dateObjUtc.toISOString();
        } else {
          eventObject.startDate = null;
        }

        const endDate = formValue?.eventInfo?.endDate;
        const endTime = formValue?.eventInfo?.endTime;
        if (endDate) {
          const [year, month, day] = endDate.split("-").map(Number);
          const [hour, minute] = endTime ? endTime.split(":").map(Number) : [0, 0];
          const dateObjUtc = new Date(Date.UTC(year, month - 1, day, hour, minute));
          eventObject.endDate = dateObjUtc.toISOString();
        } else {
          eventObject.endDate = null;
        }

        const eventDate = formValue?.eventInfo?.eventDate;
        const eventTime = formValue?.eventInfo?.eventTime;
        if (eventDate) {
          const [year, month, day] = eventDate.split("-").map(Number);
          const [hour, minute] = eventTime ? eventTime.split(":").map(Number) : [0, 0];
          const dateObjUtc = new Date(Date.UTC(year, month - 1, day, hour, minute));
          eventObject.eventDate = dateObjUtc.toISOString();
        } else {
          eventObject.eventDate = null;
        }

        const eventDoorClosingDate = formValue?.eventInfo?.eventDoorClosingDate;
        const eventDoorClosingTime = formValue?.eventInfo?.eventDoorClosingTime;
        if (eventDoorClosingDate) {
          const [year, month, day] = eventDoorClosingDate.split("-").map(Number);
          const [hour, minute] = eventDoorClosingTime
            ? eventDoorClosingTime.split(":").map(Number)
            : [0, 0];
          const dateObjUtc = new Date(Date.UTC(year, month - 1, day, hour, minute));
          eventObject.eventCloseDoorDate = dateObjUtc.toISOString();
        } else {
          eventObject.eventCloseDoorDate = null;
        }

        eventObject.eventDateList = [];
      }

      await updateEventApi(eventObject, eventID);

      const hasImageChanges =
        eventImgObject?.eventMainImg instanceof File ||
        eventImgObject?.eventCoverImg instanceof File ||
        eventImgObject?.eventSiegesImg instanceof File ||
        (Array.isArray(eventImgObject?.otherEventImgs) &&
          eventImgObject.otherEventImgs.some((img) => img instanceof File));

      if (hasImageChanges) {
        await updateEventImgsApi(eventImgObject, eventID);
      }

      Swal.fire({
        title: "Modifiée",
        text: "",
        icon: "success",
      });

      navigate("/evenements/voir");
    } catch (err) {
      Swal.fire({
        title: err.response?.data?.error || "Une erreur est survenue",
        text: "",
        icon: "error",
      });
    } finally {
      setNewEventLoading(false);
    }
  };

  const handleDescriptionValue = (value) => {
    try {
      if (formValue.description !== value) {
        // Only update state if the value is different
        setFormValue((prevFormValue) => ({
          ...prevFormValue,
          description: value,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleGetFormValues = (value) => {
    try {
      setFormValue((prevFormValue) => ({
        ...prevFormValue,
        eventInfo: value,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const handleFixCinemaTickets = async () => {
    try {
      const confirmed = await Swal.fire({
        title: "Corriger les tickets cinéma ?",
        text: "Tous les tickets de cet événement avec isCinema = false seront mis à jour à true.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Corriger",
        cancelButtonText: "Annuler",
      });
      if (!confirmed.isConfirmed) return;
      setFixCinemaLoading(true);
      const result = await fixEventCinemaTicketsApi(eventID);
      Swal.fire("Corrigé", result.message, "success");
    } catch (err) {
      Swal.fire("Erreur", err?.response?.data?.error || "Erreur lors de la correction.", "error");
    } finally {
      setFixCinemaLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" alignItems="center" gap={2}>
                <MDTypography variant="h4" fontWeight="medium">
                  Modifier cette événement
                </MDTypography>
                {formValue?.eventInfo?.isCinema && (
                  <MDBadge badgeContent="Cinéma" color="info" variant="gradient" size="md" />
                )}
                {formValue?.eventInfo?.isCirque && (
                  <MDBadge badgeContent="Cirque" color="warning" variant="gradient" size="md" />
                )}
              </MDBox>
              <MDBox mt={1} mb={2}>
                <MDTypography variant="body2" color="text"></MDTypography>
              </MDBox>
            </Grid>
            <Grid item xs={12} lg={6}>
              <MDBox display="flex" justifyContent="flex-end" gap={2}>
                {formValue?.eventInfo?.isCinema && (
                  <MDButton
                    variant="outlined"
                    color="warning"
                    onClick={handleFixCinemaTickets}
                    disabled={fixCinemaLoading}
                  >
                    {fixCinemaLoading ? "Correction..." : "Corriger isCinema tickets"}
                  </MDButton>
                )}
                {newEventLoading ? (
                  <MDBox display="flex" justifyContent="center" alignItems="center" mt={5} mb={5}>
                    <CircularProgress color="info" size={50} />
                  </MDBox>
                ) : (
                  <MDButton variant="gradient" color="info" onClick={handleUpdateEvent}>
                    Modifier
                  </MDButton>
                )}
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12} lg={4} mb={3}>
            <EventImage imgValue={handleEventMainImg} />
          </Grid>
          <Grid item xs={12} lg={8}>
            <EventImageCover imgCoverValue={handleEventCoverImg} />
          </Grid>
          <Grid item xs={12} lg={6} mt={5}>
            <EventImageSieges imgSiegeValue={handleEventSiegeImg} />
          </Grid>
          <Grid item xs={12} lg={6} mt={5}>
            <EventImages imgValues={handleEventImgs} />
          </Grid>
          <Grid item xs={12}>
            {/* <EventDescription descriptionValue={handleDescriptionValue} /> */}
            <EventDescription descriptionValue={handleDescriptionValue} />
          </Grid>
          <Grid item xs={12}>
            <FormFields formValues={handleGetFormValues} />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default UpdateEvent;
